/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MoneyFlowInfoModel { 
    date?: string;
    totalReceive?: number;
    totalRefund?: number;
    totalInvoice?: number;
}

